OE.addPlugin('Reminderpopup', (function(){

    var Plugin = {},
        Options = {
            timeout  : null, // display popup after n seconds
            reappear : 7 * 24 * 60 * 60, // when closed, reappear after n seconds
            scroll   : null, // display popup when user has scrolled the page for n percent,
            pageviews: null, // display popup when the user accesses the n-th page,
            hideifelementexists : null // if this element is found to not show the popup
        },
        class_prefix = 'popup',
        overlay_id = class_prefix + '__overlay',

        scrollTimeout = null,
        scrollThreshold = 2,

        dataAttribute = 'data-oe-reminderpopup';

    Plugin.init = function()
    {
        initPopUp();
    };

    var initPopUp = function(element)
    {
        if(typeof element === 'undefined')
        {
            var elements = OE.$doc.querySelectorAll('[' + dataAttribute + ']'),
                element_count = elements.length;

            for(var i = 0; i < element_count; i++)
            {
                initPopUp(elements[i]);
            }
        }
        else
        {
            if(!hasVisited(element) && !disablingElementsExist(element))
            {
                add_disable_popup_button(element);
                displayPopup(element);
            }
        }
    };

    var disablingElementsExist = function(popup)
    {
        var selector = getOptionsForPopup(popup).hideifelementexists;

        return selector && OE.$doc.querySelector(selector);
    };

    var add_disable_popup_button = function(popup)
    {
        var btn = popup.querySelector(_classname('disable', '.'));

        if(btn)
        {
            btn.addEventListener('click', disable_popup.bind(popup));
        }
    };

    var disable_popup = function(e)
    {
        setPopupCookie(this, 'has-visited', true, { expires : Infinity });

        var close_button = OE.$doc.querySelector(_classname('overlay', '.') + ' ' + _classname('close', '.'));

        if(close_button)
        {
            OE.Utils.triggerEvent(close_button, OE.CLICK);
        }
    };

    var getOptionsForPopup = function(element)
    {
        if(element && element.hasAttribute(dataAttribute))
        {
            if(!element.reminderpopup_options)
            {
                var popup_options = OE.Utils.getOptionsFromString(Options, element.getAttribute(dataAttribute));

                if(popup_options.scroll !== null)
                {
                    popup_options.scroll = parseInt(popup_options.scroll);
                    popup_options.scroll = Math.max(0, Math.min(100, isNaN(popup_options.scroll) ? 0 : popup_options.scroll));
                }

                if(popup_options.timeout !== null)
                {
                    popup_options.timeout = parseInt(popup_options.timeout);
                    popup_options.timeout = Math.max(0, isNaN(popup_options.timeout) ? 0 : popup_options.timeout);
                }

                if(popup_options.reappear !== null)
                {
                    popup_options.reappear = parseInt(popup_options.reappear);
                    popup_options.reappear = Math.max(0, isNaN(popup_options.reappear) ? 0 : popup_options.reappear);
                }

                if(popup_options.pageviews !== null)
                {
                    popup_options.pageviews = parseInt(popup_options.pageviews);
                    popup_options.pageviews = Math.max(1, isNaN(popup_options.pageviews) ? 1 : popup_options.pageviews);
                }

                popup_options.id = getUniqueId(element);

                element.reminderpopup_options = popup_options;
            }

            return element.reminderpopup_options;
        }

        return null;
    };

    var displayPopup = function(element)
    {
        var popup_options = getOptionsForPopup(element);

        if(popup_options)
        {
            if(popup_options.pageviews !== null)
            {
                if(display_popup_by_pageviews(element))
                {
                    return;
                }
            }

            if(popup_options.scroll !== null)
            {
                // add scroll events
                OE.$doc.addEventListener('scroll', debounced_scroll_event.bind(element));
            }

            if(popup_options.timeout !== null)
            {
                // add timeout
                display_popup_by_timeout(element);
            }
        }
    };



    var hasVisited = function(popup)
    {
        return getPopupCookie(popup, 'has-visited');
    };

    var getPopupCookie = function(popup)
    {
        var cookie = Cookies.get(getOptionsForPopup(popup).id),
            key = typeof arguments[1] === 'string' ? arguments[1] : null;

        if(cookie)
        {
            try {
                cookie = JSON.parse(cookie);
            }
            catch(ev)
            {
                cookie = {};
            }
        }
        else
        {
            cookie = {};
        }

        if(key)
        {
            if(typeof cookie[key] !== 'undefined')
            {
                return cookie[key];
            }

            return null;
        }

        return cookie;
    };

    var setPopupCookie = function(popup)
    {
        var cookie = getPopupCookie(popup),
            key = typeof arguments[1] === 'string' ? arguments[1] : null,
            value = typeof arguments[2] !== 'undefined' ? arguments[2] : null,
            options = typeof arguments[3] === 'object' ? arguments[3] : {};

        if(typeof options.expires === 'undefined')
        {
            var now_date = new Date(),
                now_offset = 0; // now.getTimezoneOffset() * 60 * 1000

            options.expires = new Date(now_date.getTime() + 1000 * getOptionsForPopup(popup).reappear - now_offset);
        }

        if(cookie)
        {
            if(key)
            {
                if(value === null)
                {
                    if(typeof cookie[key] !== 'undefined')
                    {
                        delete cookie[key];
                    }
                }
                else
                {
                    cookie[key] = value;
                }
            }

            cookie = JSON.stringify(cookie);

            Cookies.set(getOptionsForPopup(popup).id, cookie, options);

            return true;
        }

        return false;
    };


    var display_popup_by_pageviews = function(popup)
    {
        if(popup)
        {
            var pageview_count = parseInt(getPopupCookie(popup, 'pageviews'));

            if(isNaN(pageview_count))
            {
                pageview_count = 0;
            }

            pageview_count = Math.max(0, pageview_count);

            pageview_count++;

            if(pageview_count === getOptionsForPopup(popup).pageviews)
            {
                show_popup(popup, 'pageviews');
                return true;
            }

            setPopupCookie(popup, 'pageviews', pageview_count);
        }

        return false;
    };

    var debounced_scroll_event = function(e)
    {
        try { window.clearTimeout(scrollTimeout); } catch(ev) { }
        scrollTimeout = window.setTimeout(display_popup_by_scroll.bind(this, this), scrollThreshold);
    };

    var display_popup_by_scroll = function(popup)
    {
        var scrolled_percentage, scroll_threshold;
        if(popup)
        {
            scrolled_percentage = OE.Utils.getScrollPosition().top / OE.Utils.getScrollPosition().maxtop;
            scroll_threshold = getOptionsForPopup(popup).scroll / 100;

            if(scrolled_percentage >= scroll_threshold)
            {
                show_popup(popup, 'scroll');
                return true;
            }
        }

        return false;
    };

    var display_popup_by_timeout = function(popup)
    {
        if(popup)
        {
            if(getOptionsForPopup(popup).timeout)
            {
                popup.reminderpopup_timer = window.setTimeout(show_popup.bind(this, popup, 'timeout'), getOptionsForPopup(popup).timeout * 1000);

                return true;
            }
        }

        return false;
    };


    var show_popup = function(popup, shown_by)
    {
        if(popup)
        {
            try { window.clearTimeout(popup.reminderpopup_timer); } catch(ev) {};

            if(!popup.hasAttribute('reminderpopup-hash'))
            {
                var overlay = createOverlay(
                    insertContentElementIntoOverlay.bind(popup),
                    removeContentElementFromOverlay
                );
            }
        }
    };

    var insertContentElementIntoOverlay = function(overlay)
    {
        var content_wrapper = overlay.querySelector(_classname('content', '.')),
            placeholder;

        if(content_wrapper)
        {
            removeContentElementFromOverlay();

            if(this.parentElement)
            {
                if(!this.hasAttribute('reminderpopup-hash'))
                {
                    this.setAttribute('reminderpopup-hash', createHash((new Date()).getTime() + ''));
                }

                placeholder = OE.$doc.createElement('meta');
                placeholder.setAttribute('reminderpopup-placeholder', this.getAttribute('reminderpopup-hash'));
                this.parentNode.insertBefore(placeholder, this.nextSibling);

                content_wrapper.appendChild(this);
            }
        }
    };

    var removeContentElementFromOverlay = function()
    {
        var overlay = OE.$doc.querySelector(_classname('overlay', '.')),
            content_wrapper = overlay.querySelector(_classname('content', '.')),
            content_element, placeholder;

        if(content_wrapper)
        {
            content_element = content_wrapper.querySelector('[reminderpopup-hash]');

            if(content_element)
            {
                placeholder = OE.$doc.querySelector('meta[reminderpopup-placeholder="' + content_element.getAttribute('reminderpopup-hash') + '"]');

                if(placeholder)
                {
                    placeholder.parentNode.replaceChild(content_element, placeholder);
                }

                if(getPopupCookie(content_element, 'has-visited') !== true)
                {
                    setPopupCookie(content_element, 'has-visited', true);
                }
            }
        }
    };





    var getUniqueId = function(element)
    {
        if(element)
        {
            var source = element.textContent || element.getAttribute('id');
            if(!source)
            {
                source = {};
                for(var i = 0; i < element.attributes.length; i++)
                {
                    source[element.attributes[i].nodeName] =  element.attributes[i].nodeValue;
                }
                source = JSON.stringify(source);
            }
            return 'reminderpopup' + createHash(source);
        }
        return null;
    };

    var createHash = function(string)
    {
        var hash = 0, i, chr;

        if (string.length === 0){
            return hash;
        }

        for (i = 0; i < string.length; i++)
        {
            chr   = string.charCodeAt(i);
            hash  = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    };




    var _classname = function(suffix, prefix)
    {
        prefix = typeof(prefix) === 'string' ? prefix : '';
        return prefix + class_prefix + (suffix && typeof(suffix) === 'string' ? '__' + suffix : '');
    };

    var createOverlay = function(onLoadFunction, onCloseFunction)
    {
        var overlay = OE.$doc.querySelector(_classname('overlay', '.')),
            close, content_wrapper, content_div;

        if(!overlay)
        {
            overlay = OE.$doc.createElement('div');
            overlay.classList.add(_classname('overlay'));
            overlay.classList.add('is--active');

            OE.$doc.querySelector('body').appendChild(overlay);

            content_wrapper = OE.$doc.createElement('div');
            content_wrapper.classList.add(_classname('content-wrapper'));
            overlay.appendChild(content_wrapper);

            close = OE.$doc.createElement('span');
            close.textContent = '';
            close.classList.add(_classname('close'));
            close.addEventListener(OE.CLICK, closeOverlay.bind(overlay, onCloseFunction));
            content_wrapper.appendChild(close);

            content_div = OE.$doc.createElement('div');
            content_div.classList.add(_classname('content'));
            content_wrapper.appendChild(content_div);

            window.addEventListener('keyup', listen_on_esc);

            overlay.classList.add('is--active');
        }

        if(typeof onLoadFunction === 'function')
        {
            onLoadFunction(overlay);
        }

        return overlay;
    };

    var closeOverlay = function(onCloseFunction, e)
    {
        var overlay = OE.$doc.querySelector(_classname('overlay', '.')),
            transition;

        if(overlay)
        {
            transition = getOverlayTransition(overlay);
            if(transition)
            {
                overlay.addEventListener(transition, removeOverlay.bind(overlay, onCloseFunction), false);
                overlay.classList.remove('is--active');
            }
            else
            {
                removeOverlay.bind(overlay, onCloseFunction)();
            }

            overlay.classList.remove('is--active');

            window.removeEventListener('keyup', listen_on_esc);
        }
    };

    var getOverlayTransition = function(overlay)
    {
        if(overlay)
        {
            var transitions = {
                    'transition':'transitionend',
                    'OTransition':'oTransitionEnd',
                    'MozTransition':'transitionend',
                    'WebkitTransition':'webkitTransitionEnd'
                },
                transition = null,
                durations = {
                    'transitionDuration':'transitionduration',
                    'OTransitionDuration':'oTransitionDuration',
                    'MozTransitionDuration':'transitionduration',
                    'WebkitTransitionDuration':'webkitTransitionDuration'
                };

            for(var t in transitions)
            {
                if( overlay.style[t] !== undefined )
                {
                    transition =  transitions[t];
                    break;
                }
            }

            if(transition)
            {
                for(var u in durations)
                {
                    if( overlay.style[u] !== undefined )
                    {
                        if(parseInt(overlay.style[u]) > 0)
                        {
                            return transition;
                        }
                        break;
                    }
                }
            }
        }

        return null;
    };

    var removeOverlay = function(onCloseFunction, e)
    {
        var overlay = this;
        if(overlay)
        {
            if(typeof onCloseFunction === 'function')
            {
                onCloseFunction();
            }
            overlay.parentElement.removeChild(overlay);
        }
    };

    var listen_on_esc = function(e)
    {
        if(e.keyCode === 27)
        {
            var close_button = OE.$doc.querySelector(_classname('overlay', '.') + ' ' + _classname('close', '.'));

            if(close_button)
            {
                OE.Utils.triggerEvent(close_button, OE.CLICK);
            }
            else
            {
                closeOverlay();
            }
        }
    };

    return Plugin;
})());
